'use client'

import { Button } from '../../../actions/Button'
import { Dialog, DialogActions, DialogTitle } from '../../../overlays/Dialog'
import { P2 } from '../../../typography/Paragraph'
import { useMarkdownEditorRestoreContext } from '../_context/MarkdownEditorRestoreContext'

type UnsavedChangesDialogProps = {
  title: string
  description: string
}

export function UnsavedChangesDialog({ title, description }: UnsavedChangesDialogProps) {
  const { isRestoreDialogOpen, onRestore, onDiscard } = useMarkdownEditorRestoreContext()

  return (
    <Dialog open={isRestoreDialogOpen} onClose={onDiscard} type='warning' className='space-y-4'>
      <DialogTitle>{title}</DialogTitle>
      <P2 className='text-contentTertiary'>{description}</P2>
      <DialogActions>
        <Button outline onClick={onDiscard}>
          Kontynuuj bez zmian
        </Button>
        <Button color='warning' onClick={onRestore}>
          Przywróć zmiany
        </Button>
      </DialogActions>
    </Dialog>
  )
}
